// extracted by mini-css-extract-plugin
module.exports = {"container":"TqORy","empty":"R8yHp","highQualityFrame":"_3msRO","lowQualityFrame":"_32M66","thumbText":"_33xRb"};